// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__SA-56","secondary":"CloseButton_secondary__z39cO","icon":"CloseButton_icon__UsEp9","text":"CloseButton_text__VoXb+"};